import React from 'react'
import { KTIcon } from '../../../../../../_metronic/helpers'
import { IsGranted, ROLE, useAuth } from '../../../../auth'

type Props = {
  ticketToken?: string | null
  transactionId?: string | null
  paymentId?: string | null
}

const FIELD_PRIORITY: Array<[keyof Props, string]> = [
  ['ticketToken', 'ticket_token'],
  ['transactionId', 'transaction_id'],
  ['paymentId', 'payment_id'],
]

export const AuditLogLink: React.FC<Props> = (props) => {
  const { currentUser } = useAuth()
  // Логи аудита доступны только с ROLE_MANAGER (наследуется ROLE_ADMIN) —
  // совпадает с минимальной ролью бэкенда /api/internal/audit.
  // Операторы, кассиры, merchant payments operator и merchant manager её не имеют.
  if (!IsGranted([ROLE.ROLE_MANAGER], currentUser)) {
    return null
  }

  const picked = FIELD_PRIORITY.find(([key]) => {
    const value = props[key]
    return value != null && String(value).trim() !== ''
  })

  if (!picked) return null

  const [propKey, queryParam] = picked
  const value = String(props[propKey]).trim()
  const href = `/logs/audit?${queryParam}=${encodeURIComponent(value)}`

  return (
    <a
      href={href}
      target='_blank'
      rel='noopener'
      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
      title='Смотреть в логах аудита'
      onClick={(e) => e.stopPropagation()}
    >
      <KTIcon iconName='magnifier' className='fs-3' />
    </a>
  )
}
